import React from 'react'
import { css } from '@emotion/react'
import { Carousel } from '../base-ui'
import Image from '../base-ui/Image'
import config from '../../../config.json'

function ProductCarousel({ medias = [] }) {

    const carouselSettings = {
        rtl: true,
        loop: false,
        controls: true,
        // dots: true,
        preview: { sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 }
        // style: dotStyle
    }

    const carouselStyle = css`
        width: 10rem;
        height: 20rem;

        &:after {
            display: block;
            position: absolute;
            left: 0;
            bottom: 1rem;
            padding: 4px 6px;
            background-color: ${config?.theme?.colors?.primary};
            color: ${config?.theme?.colors?.white};
            border-radius: 0 5px 5px 0;
            min-width: 50%;
        }
    `
    const carouselBody = medias.map((m, idx) => {
        return (
            <div key={idx} className="keen-slider__slide" css={css`
                ${carouselStyle}
                &:after {
                    content: '${m.title}';
                }

            `}>
                <Image
                    layout="fill"
                    objectFit="cover"
                    src={
                        m?.file?.hash &&
                        `/api/filedb/${m.file.hash}.${m.file.ext}`
                    }
                    alt={m?.alt}
                />
            </div>
        )
    })
    if (medias.length > 1)
        return (
            <div>
                <Carousel {...carouselSettings}>{carouselBody}</Carousel>
            </div>
        )
    return <div>{carouselBody}</div>
}

export default ProductCarousel
